export enum TaskSorting {
    STARTED_DESC = 'started,desc',
    STARTED_ASC = 'started,asc',
    DEADLINE_DESC = 'deadline,desc',
    DEADLINE_ASC = 'deadline,asc',
    EMPTY = '',
}
